import * as Sheets from './Sheets';

export type { SheetContentProps } from './Sheets';

const {
  Sheet,
  SheetPortal,
  SheetOverlay,
  SheetTrigger,
  SheetClose,
  SheetContent,
  SheetHeader,
  SheetFooter,
  SheetTitle,
  SheetDescription,
  SheetHeaderClose,
  SheetFieldTitle,
} = Sheets;

export {
  Sheet,
  SheetPortal,
  SheetOverlay,
  SheetTrigger,
  SheetClose,
  SheetContent,
  SheetHeader,
  SheetFooter,
  SheetTitle,
  SheetDescription,
  SheetHeaderClose,
  SheetFieldTitle,
};
